<!-- 商品数量加减组件 -->
<template>
  <div class="mobile-product-num f--c">
    <div class="button f-c-c" @click="subtraction"><i class="iconfont icon-subtract-line"></i></div>
    <input :value="quantity" class="input" type="number" :min="min" :max="max" @input="productNumChange">
    <div class="button f-c-c" @click="add"><i class="iconfont icon-a-add-line1"></i></div>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'quantity',
    event: 'quantityChange'
  },
  props: {
    quantity: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: Number.MAX_SAFE_INTEGER
    },
    min: {
      type: Number,
      default: 1
    }
  },
  methods: {
    subtraction() {
      if (this.quantity > this.min) this.$emit('quantityChange', this.quantity - 1)
    },
    add() {
      if (this.quantity < this.max) this.$emit('quantityChange', this.quantity + 1)
    },
    productNumChange(e) {
      let quantity = e.target.value
      if (quantity === '') quantity = this.min
      e.target.value = quantity = ~~Number(quantity)
      this.$emit('quantityChange', quantity)
    }
  }
}
</script>

<style lang="scss" scoped>
.mobile-product-num{
  padding-top: .16rem;
  .button{
    width: .56rem;
    height: .56rem;
    border: 0.5px solid #B6B6B6;
    border-radius: 100%;
  }
  input{
    height: .5rem;
    font-size: .32rem;
    color: #99C41C;
    text-align: center;
    display: inline-block;
    width: .8rem;
    border: none;
    outline: none;
    padding: 0 0.05rem;
  }
}
</style>
